/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { ChangeEvent, FC }          from 'react';
import { useField }    from 'formik';
import { Label }       from '~/components/label';
import { InputProps }  from './types';
import { styles }      from './styles';

export const Input: FC<InputProps> = ({ name, type = 'text', label, format, description, onChange, ...props }) => {
  const [field, meta, helpers] = useField({ ...props, name, type: 'text' });
  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    // Prevents the Formik onChange from being called,
    // which would reset the input value to the initial value.
    // This is necessary when using the input with a custom format.
    if (ev.target.value !== '' && type === 'number' && (!/^[0-9\b]+$/.test(ev.target.value))) {
      ev.preventDefault();
      return;
    }

    // Update Formik value only if the input is not formatted.
    // If it is formatted, the value will be set in the handleChange function.
    //field.onChange(ev);
    onChange ? onChange(ev) : helpers.setValue(ev.target.value, true);
  }

  return (
    <label css={styles.container}>
      {label && <Label info={description}>{label}</Label>}

      <div css={styles.wrapper}>
        <input
          {...field}
          {...props}
          css={[
            styles.input,
            styles.states.default,
            meta.touched && meta.error && styles.states.error,
            format && { paddingRight: 44 }
          ]}
          onChange={handleChange}
        />
        { format &&
          <div css={styles.format}>
            {format}
          </div>
        }
      </div>

      {meta.touched && meta.error && <span css={styles.error}>{meta.error}</span>}
    </label>
  );
};
